import {createApp} from 'vue';
import SemesterCapacity from './SemesterCapacity.vue';
import {createBootstrap} from 'bootstrap-vue-next';
import VueMultiselect from 'vue-multiselect';

$(document).ready(/\/course-management\/semester-capacity$/.test(window.location.pathname)&&function() {
  const container = $('#vue-container');

  createApp(SemesterCapacity, container.data())
     .use(createBootstrap())
      .component('VMultiselect', VueMultiselect)
      .mount(container[0]);
});
